import React from "react"

import { useTranslations } from "@cirrus/core/i18n"
import Button from "@cirrus/legacy/app-components/buttons/button"

import { isDebugEnabled } from "./diagnostics"
import { ErrorContainer, ErrorMessageText, ErrorReportPre } from "./parts"
import { useStyles } from "./styles"

interface IProps {
    errorMessage: string
    errorReport?: string | null
    tryAgain: () => void
}

export const ErrorMessage = (props: IProps) => {

  const { errorMessage, errorReport, tryAgain } = props
  const styles = useStyles()
  const { i18n } = useTranslations()

    return (
        <ErrorContainer>
            <ErrorMessageText className={styles.errorMessageText}>{errorMessage}</ErrorMessageText>
            {/* Locked-down browsers (Safe Exam Browser) have no console, so the
                real error is unreadable there unless we render it. Opt-in only:
                a candidate must never be shown a stack trace. */}
            {errorReport && isDebugEnabled() ? <ErrorReportPre>{errorReport}</ErrorReportPre> : null}
            <Button
                className={styles.errorButton}
                onClick={tryAgain}>
                {i18n("General:TryAgain")}
            </Button>
        </ErrorContainer>
    )
}
